module.exports = __webpack_public_path__ + "media/images/spree/frontend/icons/gallery/right-arrow-8db285eb63648ddf55dcbd6e46a465d9.png";